import * as types from "../../redux/types";
import backend from "../../api/api";
import history from "../../history";
import { store } from "../../redux/store";


const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const checkBrandExists = (brandName) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/product/brand/check_duplicate/?name=${encodeURIComponent(brandName)}`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return { exists: false, brands: [] };
  }
};

// Update createBrand to handle force parameter
export const createBrand = (formValues, force = false) => async (dispatch) => {
  formValues["data"] = "";
  formValues["force"] = force;
  try {
    const response = await backend.post(
      "api/product/brand/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_BRAND,
        payload: { ...response.data },
      });
      history.push("/product/brand");
      return response;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getAllBrand = () => async (dispatch) => {
  try {
    const response = await backend.get("api/product/brand/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_BRAND,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteBrand = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/product/brand/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_BRAND, payload: id });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateBrand = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/product/brand/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({ type: types.UPDATE_BRAND, payload: { ...response.data } });
    }
  } catch (error) {
    console.log(error.response);
  }
};
